
import { mergeData } from 'vue-functional-data-merge'

import { ThemeMixin } from '../../mixins'

export default ThemeMixin.extend({
  name: 'WeveTextareaSkeleton',
  functional: true,
  render(h, { data, injections }) {
    return h(
      'div',
      mergeData(data, {
        staticClass: 'app-textarea-skeleton app-form-element-skeleton',
        class: {
          'w-theme--light': injections.theme === 'light',
          'w-theme--dark': injections.theme === 'dark',
        },
      }),
      [
        h('div', {
          staticClass: 'skeleton-element app-textarea-skeleton__label',
        }),
        h('div', {
          staticClass: 'skeleton-element app-textarea-skeleton__container',
        }),
      ],
    )
  },
})
